import { memo, useContext } from 'react';

import BondDirectoryView from './components/BondDirectoryView';
import { BondDirectoryProvider } from './context/bond-directory-context';
import useAuthStore from '@store/useAuthStore';
import AuthContext from '@context/auth';
import OpportunitiesCarousel from '@components/Homepage/OpportunitiesCarousel';
import useHomePageDeal from '@components/Homepage/OpportunitiesCarousel/hooks/useHomePageDeal';

const BondDirectory = ({ homepageDealsResponse, params }) => {
    const { isLogged } = useAuthStore();
    const { signUpModal } = useContext(AuthContext);
    const { homePageDeals, error: homePageDealsError } = useHomePageDeal({
        homepageDealsResponse,
    });

    return (
        <main className="">
            <BondDirectoryProvider params={params}>
                <BondDirectoryView params={params} />
            </BondDirectoryProvider>

            <section className={'relative bg-bgColor-50'}>
                {homePageDeals.length > 0 && !homePageDealsError ? (
                    <OpportunitiesCarousel
                        signUpModal={signUpModal}
                        isLogged={isLogged}
                        opportunities={homePageDeals}
                        className={'md:pt-20'}
                        showCta
                        scaleFactor={0.75}
                    />
                ) : null}
            </section>
        </main>
    );
};

export default memo(BondDirectory);
